import Vue from 'vue';
import VDatepicker from 'vue2-datepicker';

export let DatePicker;

if (!!window.MSInputMethodContext && !!document.documentMode) {
  // is IE11
  DatePicker = Vue.extend({
    ...VDatepicker,
    methods: {
      ...VDatepicker.methods,
      blur() {
        // In the overridden method the input element is blurred.
        // This causes IE11 to lose the keyboard focus.
      },
    },
  });
} else {
  DatePicker = VDatepicker;
}

export default DatePicker;
